// Polyfills for Office Add-in environment
// This file must be imported BEFORE any other imports

// Polyfill history API for Clerk compatibility
const noopHistory = {
  replaceState: () => {},
  pushState: () => {},
  go: () => {},
  back: () => {},
  forward: () => {},
  state: null,
  length: 1,
};

// Patch globalThis.history
if (typeof globalThis !== "undefined") {
  if (!globalThis.history) {
    (globalThis as any).history = noopHistory;
  } else {
    // Patch individual methods if they're missing or null
    const h = globalThis.history as any;
    if (!h.replaceState || h.replaceState === null) {
      h.replaceState = () => {};
    }
    if (!h.pushState || h.pushState === null) {
      h.pushState = () => {};
    }
  }
}

// Patch window.history
if (typeof window !== "undefined") {
  if (!window.history) {
    (window as any).history = noopHistory;
  } else {
    // Patch individual methods if they're missing or null
    const h = window.history as any;
    if (!h.replaceState || h.replaceState === null) {
      try {
        Object.defineProperty(window.history, 'replaceState', {
          value: () => {},
          writable: true,
          configurable: true,
        });
      } catch (e) {
        // If defineProperty fails, try direct assignment
        (window.history as any).replaceState = () => {};
      }
    }
    if (!h.pushState || h.pushState === null) {
      try {
        Object.defineProperty(window.history, 'pushState', {
          value: () => {},
          writable: true,
          configurable: true,
        });
      } catch (e) {
        (window.history as any).pushState = () => {};
      }
    }
  }
}

console.log("[Rima Excel] Polyfills loaded");
console.log("[Rima Excel] history.replaceState type:", typeof globalThis?.history?.replaceState);
